import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forms-layout',
  templateUrl: './forms-layout.component.html',
  styleUrls: ['./forms-layout.component.scss']
})
export class FormsLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
